<main>
	<div class="select-wrapper">
		<h1>Retrieving foundation accounts</h1>
		<h2> Welcome, {{agentProfileData?agentProfileData.agentName:''}}</h2>
		<h3>Retrieving foundation accounts associated with this customer</h3>
		<!-- <h4 *ngIf="!fansRetrieved && !showErrors">Retrieving foundation accounts associated with this customer</h4> -->
		<div class="loader" *ngIf="!fansRetrieved && !showErrors" >
			<img src="assets/img/spinner.svg" />
			<p class="loadingText">loading..</p>
		</div>
		<div class="alert valign-children-middle" *ngIf="fansRetrieved && !showErrors">
			<div class="alert-success" aria-label="Information">
				<i class="icon-flat-info"></i>
			</div>
			<div>
					Foundation accounts were successfully retrieved. You are being redirected to AT&T Business Console.
			</div>
		</div>
		<div *ngIf="showErrors" class="alert valign-children-middle">
			<div class="alert-info" aria-label="Information">
				<i class="icon-flat-info"></i>
			</div>
			<div>
				<span>Foundation accounts could not be loaded.Continue with single foundation account or Return to customer data using the buttons below.</span>
			</div>
		</div>
		 <div *ngIf="showErrorsPermission" class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Error">
            <i class="icon-badgealert"></i>
        </div>
        <div>
            <span>{{errorMessage}}</span>
        </div>
    </div>
		<!--<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>-->
		<!--<p> You have selected <b>{{SelectedFANList.ctnNumber}}</b> Foundational accounts.</p> -->
		<div class="row">
			<div class="col-sm-12 col-md-12 buttons-section">
				<button href="javascript:void(0)" (click)="backToCallingPage()" class="btn btn-default">Return to cutomer data</button>
				<button (click)="continueToNext('continueWithSingle')" class="btn btn-secondary">Continue with single foundation account</button>
			</div>
		</div>
		<hr>
		<div>
			<h3>Customer:</h3>
			<div class="row">
				<div class="col-md-3 col-sm-12 c-detail">
					<div>Customer account number</div>
					<div>{{agentProfileData.searchFan}}</div>
				</div>
				<div class="col-md-3 col-sm-12 c-detail">
						<div>Customer name</div>
						<div>{{agentProfileData.customerName}}</div>
				</div>
				<div class="col-md-3 col-sm-12 c-detail">
						<div>Customer email</div>
						<div>{{agentProfileData.customerEmail.toUpperCase()}}</div>
				</div>
				<div class="col-md-3 col-sm-12 c-detail">
					<button [disabled]="!agentProfileData.showResetOption" (click)="backToCustomerEntryPage()" class="btn btn-default pull-left">
					Reset
					</button>
				</div>
			</div>
		</div>
	</div>
</main>